<template>
  <div class="course-box">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <!--      <el-breadcrumb-item :to="{ path: '/participation/train' }">参加培训任务</el-breadcrumb-item>-->
      <el-breadcrumb-item>参加培训任务</el-breadcrumb-item>
      <el-breadcrumb-item>计划课程</el-breadcrumb-item>
    </el-breadcrumb>
    <PublicSearch class="user-search" :searchData="searchData" @onSearch="() => { pageInfo.currentPage = 1; getData() }">
      <template #right>
        <el-button size="small" class="mg-btm20" @click="$router.back()">返回</el-button>
      </template>
    </PublicSearch>
    <my-table height="80%" :columns="customColumns" :tableData="tableData" :loading="isLoading"
      @selection-change="handleSelectionChange" @row-click="handleRowClick">
      <template #courseName="item">
        <div class="col-29f cs-pit" @click="handleAction(1, item)">{{ item.row.courseName }}</div>
      </template>
      <template #time="item">
        <div>{{ item.row.startTime.split(' ')[0] }}至{{ item.row.endTime ? item.row.endTime : '不限' }}</div>
      </template>
      <template #rate="item">
        <div>{{ item.row.rate }}%</div>
      </template>
    </my-table>
    <div class="main-pagination">
      <Pagination :child-msg="pageInfo" @callFather="callFather"></Pagination>
    </div>
  </div>
</template>

<script>
import PublicSearch from '@/components/publicSearch.vue';
import MyUpload from '@/components/myUpload.vue';
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import myImportDialog from '@/components/myImportDialog.vue';
import api from '../../api/participationTrain/index';
import { fileDownload } from "../../utils/util";
export default {
  components: {
    PublicSearch,
    MyUpload,
    MyTable,
    Pagination,
    myForm,
    myImportDialog
  },
  data () {
    return {
      searchData: {
        inputList: [
          { label: '课程名称：', prop: 'courseName', type: 'input', placeholder: '请输入课程名称' }
        ],
        searchQuery: {} //  搜索参数
      }, //  搜索参数
      customColumns: [
        { label: '课程名称', slot: 'courseName' },
        { label: '学习时间', slot: 'time' },
        { label: '学习进度', slot: 'rate' }
      ],
      isLoading: false,
      tableData: [],
      pageInfo: { currentPage: 1, pageSize: 10, total: 0 } //  分页参数
    }
  },
  created () {
    this.getDictionary();
    this.getData();
  },
  methods: {
    getDictionary () {
    },
    //  改变分页及大小
    callFather (data) {
      this.pageInfo.currentPage = data.currentPage;
      this.pageInfo.pageSize = data.pageSize;
      this.getData();
    },
    //  获取数据
    async getData () {
      const params = {
        pageNum: this.pageInfo.currentPage,
        pageSize: this.pageInfo.pageSize,
        planId: this.$route.query.planId
      };
      const res = await api.trainCourseMyPage({ ...this.searchData.searchQuery, ...params });
      this.tableData = res.data.records;
      this.pageInfo.total = res.data.total;
    },
    async handleAction (index, data) {
      switch (index) {
        case 1:
          await this.$router.push({
            path: '/participation/courseDetail',
            query: { courseId: data.row.courseId, planId: this.$route.query.planId }
          })
          break;
      }
    },
    handleSelectionChange (selection) {
      console.log('选择发生变化：', selection);
    },
    handleRowClick (row) {
      console.log('点击行：', row);
    }
  }
}
</script>

<style lang="scss" scoped>
.course-box {
  height: 100%;

  .user-search {
    margin-top: 20px;
  }

  .operate {
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }
  }

  .view-list {
    width: 70%;
    margin: 0 auto;
    font-size: 16px;

    .view-item {
      display: flex;
      align-items: flex-start;
      padding: 5px 0;

      .view-label {
        width: 100px;
        text-align: right;
      }
    }
  }
}
</style>
<style lang="scss">
.el-loading-mask {
  z-index: 5000 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/participationTrain/course.vue